"use client";
import React, { useEffect, useRef, useState } from "react";
import { getListChapters, initialBookStateFromStorage, setBookStateToStorage } from "@/redux/reducers/book.reducer";
import { HeadModule } from "@/layouts/styles/ssr.style";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "@/redux/store";
import { Button, Dropdown, Space } from "antd";
import { IoCheckmarkDoneOutline } from "react-icons/io5";
import { userInfo, postSettingUser, getSettingUser, initialUserStateFromStorage, setUserStateToStorage } from "@/redux/reducers/user.reducer";
import { IoIosColorPalette } from "react-icons/io";
import { CgFontSpacing } from "react-icons/cg";
import { RiFontFamily } from "react-icons/ri";
import { FaCaretDown } from "react-icons/fa6";
import { BiFontSize } from "react-icons/bi";
import { setTheme } from "@/redux/reducers/theme.reducer";
import { fontValues } from "@/data";
import { CiCircleMinus, CiCirclePlus } from "react-icons/ci";
import { useAuth } from "@/hooks";

type ISettingLocal = {
    contentColor?: string;
    bgColor?: string;
};

function DisplaySetting({ onClose }: { onClose: () => void }) {
    const dispatch = useDispatch<AppDispatch>();
    const [colorSetting, setColorSetting] = useState<ISettingLocal>({});
    const { isAuth } = useAuth();
    const userData = useSelector(userInfo);

    const changeSetting = async (key: string, value: any) => {
        try {
            const data = { ...userData.settings, [key]: value };
            if (isAuth) {
                // console.log(data);
                await dispatch(postSettingUser(data));
                await dispatch(getSettingUser());
            } else {
                // dispatch(updateUserSettings());
            }
        } catch (error) {
            console.log(error);
        }
    };

    const chooseValueBgColor = async (background_color: string, content_color: string) => {
        let item = {
            content_color,
            background_color,
        };

        const data = { ...userData.settings, background_color, content_color };
        if (isAuth) {
            await dispatch(postSettingUser(data));
            await dispatch(getSettingUser());
        } else {
            // dispatch(updateUserSettings(data));
        }
        dispatch(setTheme(item));
        localStorage.setItem("themeChapter", JSON.stringify(item));
        onClose();
    };

    const handleMenuClick = (e: any) => {
        changeSetting("font_family", e.key);
    };

    const chooseFontValuesProps = {
        items: fontValues,
        onClick: handleMenuClick,
    };

    return (
        <div className="p-1">
            <div className="flex items-center justify-between pb-3">
                <HeadModule>Cài đặt hiển thị</HeadModule>
            </div>
            <div className="text-base grid md:grid-cols-2 gap-y-8" style={{ gridTemplateColumns: "35% auto" }}>
                <div className="text-slate-500 table-footer-group">
                    <IoIosColorPalette className="float-left" size={24} />
                    Màu nền
                </div>
                <div className="list-none grid md:grid-cols-4 gap-y-4 ">
                    <div
                        className="rounded-full w-10 h-10 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                            chooseValueBgColor("#f5e4e4", "#ebcaca");
                        }}
                        style={{ background: "#f5e4e4", border: "1px solid #ebcaca" }}
                    >
                        {colorSetting.bgColor === "#f5e4e4" && <IoCheckmarkDoneOutline size={20} color="#64748B" />}
                    </div>
                    <div
                        className="rounded-full w-10 h-10 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                            chooseValueBgColor("#f5ebcd", "#efdfaf");
                        }}
                        style={{ background: "#f5ebcd", border: "1px solid #efdfaf" }}
                    >
                        {colorSetting.bgColor === "#f5ebcd" && <IoCheckmarkDoneOutline size={20} color="#64748B" />}
                    </div>
                    <div
                        className="rounded-full w-10 h-10 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                            chooseValueBgColor("#e2eee2", "#cbe1cb");
                        }}
                        style={{ background: "#e2eee2", border: "1px solid #cbe1cb" }}
                    >
                        {colorSetting.bgColor === "#e2eee2" && <IoCheckmarkDoneOutline size={20} color="#64748B" />}
                    </div>
                    <div
                        className="rounded-full w-10 h-10 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                            chooseValueBgColor("#e1e8e8", "#cdd9d9");
                        }}
                        style={{ background: "#e1e8e8", border: "1px solid #cdd9d9" }}
                    >
                        {colorSetting.bgColor === "#e1e8e8" && <IoCheckmarkDoneOutline size={20} color="#64748B" />}
                    </div>
                    <div
                        className="rounded-full w-10 h-10 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                            chooseValueBgColor("#eae4d3", "#ded5bb");
                        }}
                        style={{ background: "#eae4d3", border: "1px solid #ded5bb" }}
                    >
                        {colorSetting.bgColor === "#eae4d3" && <IoCheckmarkDoneOutline size={20} color="#64748B" />}
                    </div>
                    <div
                        className="rounded-full w-10 h-10 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                            chooseValueBgColor("#e5e3df", "#d5d2cb");
                        }}
                        style={{ background: "#e5e3df", border: "1px solid #d5d2cb" }}
                    >
                        {colorSetting.bgColor === "#e5e3df" && <IoCheckmarkDoneOutline size={20} color="#64748B" />}
                    </div>
                    {/* <div
                        className="rounded-full w-10 h-10 cursor-pointer"
                        onClick={() => {
                            chooseValueBgColor("#222", "#101010");
                        }}
                        style={{ background: "#222", border: "1px solid #101010" }}
                    ></div> */}
                    <div
                        className="rounded-full w-10 h-10 cursor-pointer flex items-center justify-center"
                        onClick={() => {
                            chooseValueBgColor("#fff", "#ededed");
                        }}
                        style={{ background: "#fff", border: "1px solid #ededed" }}
                    >
                        {colorSetting.bgColor === "#fff" && <IoCheckmarkDoneOutline size={20} color="#64748B" />}
                    </div>
                </div>
                {/* tạm comment xử lý đoạn này sau */}
                <div className="flex items-center text-slate-500">
                    <RiFontFamily className="float-right" size={24} />
                    {userData.settings.font_family ?? "Font chữ"}
                </div>
                <div>
                    <Dropdown menu={chooseFontValuesProps} placement="bottom">
                        <Button className="min-w-full text-left">
                            <Space className="flex justify-between">
                                {userData.settings.font_family ?? "Font chữ"}
                                <FaCaretDown />
                            </Space>
                        </Button>
                    </Dropdown>
                </div>

                <div className="flex items-center text-slate-500">
                    <BiFontSize className="float-right" size={24} />
                    Cỡ chữ
                </div>
                <div className="flex justify-between items-center">
                    <CiCircleMinus
                        size={40}
                        className="text-slate-500 cursor-pointer"
                        onClick={() => {
                            console.log(userData.settings.font_size);
                            if (userData.settings.font_size) {
                                if (userData.settings.font_size > 12) {
                                    changeSetting("font_size", userData.settings.font_size - 1);
                                }
                            }
                        }}
                    />
                    <span className="font-semibold">{userData.settings.font_size ?? 16}px</span>
                    <CiCirclePlus
                        size={40}
                        className="text-slate-500 cursor-pointer"
                        onClick={() => {
                            console.log(userData.settings.font_size);
                            if (userData.settings.font_size) {
                                if (userData.settings.font_size < 30) {
                                    changeSetting("font_size", userData.settings.font_size + 1);
                                }
                            }
                        }}
                    />
                </div>

                <div className="flex items-center text-slate-500">
                    <CgFontSpacing className="float-right" size={24} />
                    Khoảng trắng
                </div>
                <div className="flex justify-between items-center font-semibold">
                    <CiCircleMinus
                        size={40}
                        className="text-slate-500 cursor-pointer"
                        onClick={() => {
                            if (userData.settings.space_column) {
                                if (userData.settings.space_column > 0) {
                                    changeSetting("space_column", userData.settings.space_column - 1);
                                }
                            }
                        }}
                    />
                    <span className="font-semibold">{userData.settings.space_column ?? 0}px</span>
                    <CiCirclePlus
                        size={40}
                        className="text-slate-500 cursor-pointer"
                        onClick={() => {
                            if ((userData.settings.space_column as number) < 5) {
                                changeSetting("space_column", (userData.settings.space_column as number) + 1);
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default DisplaySetting;
